export default __webpack_public_path__ + "static/media/payment-felix.f6f7ce28.svg";